$(document).ready(function() {

    /* Header loader */
     $(window).on('load', function () {
          $(".s-panel .wbslideloader").removeClass("wbsload");
     });

    // slider
    $('.owl-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1
    });
    // Header Menu Carousel
    $('#owl-menuproduct').owlCarousel({
        itemsCustom : [
        [0, 1],
        [320, 2],
        [600, 2],
        [768, 2],
        [992, 2],
        [1200, 2],
        [1410, 2]
        ],
        // autoPlay: 1000,
        navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        navigation : false,
        pagination:true
        });

    // All Product
    $(".owl-fea,.owl-latest,.owl-best").owlCarousel({
    itemsCustom : [
    [0, 1],
    [320, 2],
    [600, 3],
    [768, 3],
    [992, 3],
    [1200, 4],
    [1410, 5]
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : true,
    pagination:false
    });

    $(".owl-bestp").owlCarousel({
    itemsCustom : [
    [0, 1],
    [600, 2],
    [768, 1],
    [992, 2],
    [1200, 2],
    [1410, 2]
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : true,
    pagination:false
    });


    $(".owl-catt").owlCarousel({
    itemsCustom : [
	[0, 1],
	[320, 1],
	[450, 2], 
	[600, 2],
	[768, 2],
	[992, 3],
	[1200, 3],
	[1410, 4]
    ],
    autoPlay: 3000,
    stopOnHover: true,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : true,
    pagination:false
    });

  	// special
    $(".owl-spe").owlCarousel({
    itemsCustom : [
    [0, 1],
    [450, 1], 
    [600, 1],
    [768, 1],
    [992, 1],
    [1200,2],
    [1410, 2]   
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : true,
    pagination:false
    });

    // testimonial
    $('.testi').slick({
        dots: false,
        arrows: true,
        centerMode: true,
        centerPadding: '0px',
        autoplay: false,
        autoplaySpeed: 5000, 
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
           {
            breakpoint: 1590,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
    });

    
    // blog

    $(".owlblog").owlCarousel({
    itemsCustom : [
    [0, 1],
    [600, 2],
    [768, 1],
    [992, 2],
    [1200, 2],
    [1410, 2],
    [1590, 2]
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : true,
    pagination:false
    });

     // related products
    $(".related-products").owlCarousel({
    itemsCustom : [
    [0, 1],
    [320, 2],
    [600, 3],
    [768, 3],
    [992, 4],
    [1200, 4],
    [1410, 5]   
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : true,
    pagination:false
    });
    
    // Popup Product
    $('.wbpopup-popducts .popinner').hide();
    var i = 0;
    setIntervalFun();
    var totalTimer = parseInt(3000) + parseInt(2000);
    setInterval( setIntervalFun, totalTimer);
    function setIntervalFun()
    {
        $('.wbpopup-popducts .popinner').eq(i).fadeIn(400);
        setTimeout(function(){
            $('.wbpopup-popducts .popinner').eq(i).fadeOut(400);
            i++;
            if ($('.wbpopup-popducts .popinner').length <= i) {
                i = 0;
            }
        },parseInt(7000));
    }
    $(document).on('click', '.wbclosepopup', function(){
        $('.wbpopup-popducts').fadeOut(400).remove();
    });

    // Box Layout
    $(".wbboxdemo").click(function(){
        $(".wbboxlt").attr("id","wbboxlayout");
    });
    $(".wbwidedemo").click(function(){
        $(".wbboxlt").removeAttr("id");
    }); 
    // Color Customizer
    $("body").on("click", ".wbinnerclr a", function(e){
    e.preventDefault();
    $('.wbinnerclr').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbcolorname=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("head").append('<link rel="stylesheet" type="text/css" wbcolorname href="' + $(this).attr('href') + '">');
    });
    // Rtl Mode
    $("body").on("click", ".wbrtlmode a", function(e){
    e.preventDefault();
    $('.wbrtlmode').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbrtl=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("head").append('<link rel="stylesheet" type="text/css" wbrtl href="' + $(this).attr('href') + '">');
    });
    // Color Open/Close 
    $('.wbopen-closeclr').click(function() {
        if ($(this).hasClass('wbclrdisable')) {
            $(this).removeClass('wbclrdisable');
            $(this).addClass('wbclrenable');
            $('.wbcolor_box').animate({right: '30px'}, 450);
            $('.wbcolor_box').css({'box-shadow': '0 10px 35px 10px rgba(0,0,0,.06)', 'background': '#fff', 'border-radius': '4px 0 4px 4px'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '1'}, 450);
        } else {
            $(this).removeClass('wbclrenable');
            $(this).addClass('wbclrdisable');
            $('.wbcolor_box').animate({right: '-250px'}, 450);
            $('.wbcolor_box').css({'box-shadow': 'none', 'background': 'transparent'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '0'}, 450);
        }
    });
  
  // header menu more
    if ($(document).width() >= 1200){
         var count_block = $('#wbmegalevel-1 .wbmenul_1').length;
         var number_blocks = 10;
         if(count_block < number_blocks){
              return false; 
         } else {
              
              $('#wbmegalevel-1 .wbmenul_1').each(function(i,n){
                    if(i == number_blocks) {
                         $('#wbmegalevel-1').append('<li class="view_more wbmenul_1"><div class="thumb_img"><i class="fa fa-plus"></i><a class="dropdown-item wbmenul1_link">More</a></div></li>');
                    }
                    if(i> number_blocks) {
                         $(this).addClass('wr_hide_menu');
                    }
              })
              $('.wr_hide_menu').hide();
              $('.view_more.wbmenul_1').click(function() {
                    $(this).toggleClass('active');
                    $('.wr_hide_menu').slideToggle();
              });
         }
    }

    if (($(document).width() >= 992) && ($(document).width() <= 1199)) {
         var count_block = $('#wbmegalevel-1 .wbmenul_1').length;
         var number_blocks = 6;
         if(count_block < number_blocks){
              return false; 
         } else {
              
              $('#wbmegalevel-1 .wbmenul_1').each(function(i,n){
                    if(i == number_blocks) {
                         $('#wbmegalevel-1').append('<li class="view_more wbmenul_1"><div class="thumb_img"><i class="fa fa-plus"></i><a class="dropdown-item wbmenul1_link">More</a></div></li>');
                    }
                    if(i> number_blocks) {
                         $(this).addClass('wr_hide_menu');
                    }
              })
              $('.wr_hide_menu').hide();
              $('.view_more.wbmenul_1').click(function() {
                    $(this).toggleClass('active');
                    $('.wr_hide_menu').slideToggle();
              });
         }
    }

  
  // product category 1
    $(".owl-procat").owlCarousel({
    itemsCustom : [
    [0, 1],
    [450, 2], 
    [600, 3],
    [768, 3],
    [992, 2],
    [1200, 3],
    [1410, 3]
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : true,
    pagination:false
    });
    
    if (($(window).width() >= 768)){
        var count_block = $('.product-category-1 .ptabbr .tab-menu').length;
        var number_blocks = 3;
        if(count_block < number_blocks){
            return false; 
        } else {
                $('.product-category-1 .ptabbr .tab-menu').each(function(i,n){
                     if(i> number_blocks) {
                            $(this).addClass('it_hide_wbtab-1');
                        }
                });
                 $('.it_hide_wbtab-1').hide();
                $('.product-category-1 .proview_cat-1').click(function() {
                    $(this).toggleClass('active');
                    $('.it_hide_wbtab-1').slideToggle();
                });
        };
    }


    // product category 2
    $(".owl-procat1").owlCarousel({
    itemsCustom : [
    [0, 1],
    [450, 2], 
    [600, 3],
    [768, 3],
    [992, 2],
    [1200, 3],
    [1410, 3]
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : true,
    pagination:false
    });
    
    if (($(window).width() >= 768)){
        var count_block = $('.product-category-2 .ptabbr .tab-menu').length;
        var number_blocks = 3;
        if(count_block < number_blocks){  
            return false; 
        } else {
                $('.product-category-2 .ptabbr .tab-menu').each(function(i,n){
                     if(i> number_blocks) {
                            $(this).addClass('it_hide_wbtab-2');
                        }
                });
                 $('.it_hide_wbtab-2').hide();
                $('.product-category-2 .proview_cat-2').click(function() {
                    $(this).toggleClass('active');
                    $('.it_hide_wbtab-2').slideToggle();
                });
        };
}

  
    // append section
    if ($(document).width() >= 992){
    $('.snavb').appendTo('.leftw');
    }
    if ($(window).width() <= 991) {
        $('.wbhm').appendTo('.wbmenuapp');
    };
    if(jQuery(window).width() >= 320 && jQuery(window).width() <= 767){
      $('.rightac').appendTo('.appcart');
      $('.topws').appendTo('.wscur .dropdown-menu .header-panel-top');
      $('.appcry').appendTo('.wscur .dropdown-menu');
  }

    // sticky js
    if ($(document).width() >= 768){
    $(window).scroll(function () {
        if ($(this).scrollTop() > 165) {
            $('.fixed-cms').addClass('fixed fadeInDown animated');
        } else {
            $('.fixed-cms').removeClass('fixed fadeInDown animated'); 
        }
    });
    };

    
   
 

    // Mobile Menu Toggle
    if ($(window).width() <= 991) {
	    $('.wbmegamainhd').on('click', function() {
	        var targetMenu = '#' + $(this).data('submenu');
	        $(targetMenu).slideToggle(300);
	        $(this).toggleClass('active');
	        return false;
	    });
	};



});  // Document Ready End

$(window).load(function myFunction() {
  $(".s-panel .loader").removeClass("wrloader");
});

// Menu For Mobile
function w3_open() {
    document.getElementById("myOverlay").style.display = "block";
    document.getElementById("megamenu").className = "active menu-fixed";
    $('body').addClass("wbbodyscroll");
}
function w3_close() {
    document.getElementById("myOverlay").style.display = "none";
    document.getElementById("megamenu").className = "menu-fixed";
    $('body').removeClass("wbbodyscroll");
}